import { render, staticRenderFns } from "./MedecinsRandom.vue?vue&type=template&id=6a00d6ae&"
import script from "./MedecinsRandom.vue?vue&type=script&lang=js&"
export * from "./MedecinsRandom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports